import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/house-tau-logo.jpg';
import './Footer.css';

const SOCIALS = [
  {
    name: 'House TAU',
    label: 'House TAU on Instagram',
    href: 'https://www.instagram.com/housetau/',
    icon: 'instagram',
  },
  {
    name: 'Baltsazar',
    label: 'Baltsazar on Instagram',
    href: 'https://www.instagram.com/baltsazar_official/',
    icon: 'instagram',
  },
  {
    name: 'Facebook',
    label: 'House TAU on Facebook',
    href: 'https://www.facebook.com/p/House-TAU-100076156011520/',
    icon: 'facebook',
  },
];

function Icon({ type }) {
  if (type === 'instagram') {
    return (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 8.5h2.2V5.2h-2.3c-2.4 0-3.9 1.5-3.9 4v2.1H8.6v3.3h2.4V21h3.4v-6.4h2.4l.4-3.3h-2.8v-1.7c0-.9.3-1.1 1.2-1.1Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__inner">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo-link">
              <img src={logo} alt="House TAU crest" className="site-footer__logo" />
              <span>House TAU</span>
            </Link>
            <p className="site-footer__motto">Iron Sharpens Iron · Est. 1963</p>
          </div>

          <nav className="site-footer__links">
            <Link to="/about">The House</Link>
            <Link to="/the-eiffel">The Eiffel</Link>
            <Link to="/baltsazar">Baltsazar</Link>
            <Link to="/gallery">Gallery</Link>
          </nav>

          <div className="site-footer__socials">
            {SOCIALS.map((s) => (
              <a
                key={s.href}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="site-footer__social-icon"
              >
                <Icon type={s.icon} />
                <span>{s.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} House TAU, University of Pretoria.</span>
        </div>
      </div>
    </footer>
  );
}
